import styled from 'styled-components';
import { Popup } from 'react-map-gl/mapbox';
import { mixins } from 'sonata-react-components';

export const MapPopupStyled = styled(Popup)`
  .mapboxgl-popup-anchor-right {
    .mapboxgl-popup-tip {
      border-left-color: ${props => props.theme.uiColors.backgroundReportingMapPopup} !important;
    }
  }
  .mapboxgl-popup-anchor-left {
    .mapboxgl-popup-tip {
      border-right-color: ${props => props.theme.uiColors.backgroundReportingMapPopup} !important;
    }
  }
  :not(.mapboxgl-popup-anchor-right,.mapboxgl-popup-anchor-left) {
    .mapboxgl-popup-tip {
      border-bottom-color: ${props => props.theme.uiColors.backgroundReportingMapPopup};
      border-top-color: ${props => props.theme.uiColors.backgroundReportingMapPopup};
    }
  }
  .mapboxgl-popup-content {
    min-width: 100px;
    width: unset !important;
    background: ${props => props.theme.uiColors.backgroundReportingMapPopup};
    color: ${props => props.theme.uiColors.textBodyDefault};
  }
`;

export const MapStyle = styled.div`
  height: 100%;
  width: 100%;

  .shortcutsContainer {
    position: absolute;
    top: 75px;
    right: 20px;
  }

  .overlays {
    pointer-events: none !important;

    .mapboxgl-ctrl-bottom-right {
      bottom: 25px;
    }
  }

  .mapboxgl-map {
    height: 100%;

    .mapboxgl-ctrl-group {
      margin: 0;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    }

    .mapboxgl-ctrl-group > button {
      margin: 0;
      width: 40px;
      height: 40px;
    }

    .mapboxgl-ctrl-bottom-left {
      margin: 0 0 10px 10px;
      transition: left 0.5s ease-in-out;
      left: 0;

      .mapboxgl-ctrl-group {
        border-radius: 0 0 0 0;

        &:first-child {
          border-radius: 4px 4px 0 0;
        }

        &:last-child {
          border-radius: 0 0 4px 4px;
        }
      }
    }

    .mapboxgl-ctrl-bottom-right {
      margin: 0 10px 0 0;
      transition: left 0.5s ease-in-out;
      right: 0;

      .mapboxgl-ctrl-group {
        margin-bottom: 10px !important;
      }
    }

    .mapboxgl-ctrl-top-left {
      margin: 10px 0 0 10px;
      transition: left 0.5s ease-in-out;
      left: 0;

      .mapboxgl-ctrl-group {
        border-radius: 0 0 0 0;

        &:first-child {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }

        &:last-child {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }

    .mapboxgl-ctrl-top-right {
      margin: 10px 10px 0 0;
      transition: left 0.5s ease-in-out;
      right: 0;

      .mapboxgl-ctrl-group {
        border-radius: 0 0 0 0;

        &:first-child {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }

        &:last-child {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }
  }

  .closeMapButton {
    height: 40px;
    width: 40px;
    padding: 0;
  }

  .mapboxgl-ctrl-group {
    margin: 0;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  }

  .mapboxgl-ctrl-group > button {
    margin: 0;
    width: 40px;
    height: 40px;
  }

  .mapboxgl-ctrl-bottom-left {
    margin: 0 0 10px 10px;
    transition: left 0.5s ease-in-out;
    left: 0;
    z-index: 1 !important;

    .mapboxgl-ctrl-group {
      border-radius: 0 0 0 0;

      &:first-child {
        border-radius: 4px 4px 0 0;
      }

      &:last-child {
        border-radius: 0 0 4px 4px;
      }
    }
  }

  .mapboxgl-ctrl-bottom-right {
    margin: 0 10px 0 0;
    transition: left 0.5s ease-in-out;
    right: 0;

    .mapboxgl-ctrl-group {
      margin-bottom: 10px !important;
    }
  }

  .mapboxgl-ctrl-top-left {
    margin: 10px 0 0 10px;
    transition: left 0.5s ease-in-out;
    left: 0;

    .mapboxgl-ctrl-group {
      border-radius: 0 0 0 0;

      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }

  .mapboxgl-ctrl-top-right {
    margin: 10px 10px 0 0;
    transition: left 0.5s ease-in-out;
    right: 0;

    .mapboxgl-ctrl-group {
      border-radius: 0 0 0 0;

      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }

  .mapboxButton {
    border-bottom: 1px solid #ddd;
    margin: 0 0 0 0 !important;
    background-color: #fff;
    z-index: 1;
  }

  .mapboxgl-popup-content {
    font-size: 0.8rem;
    width: 640px;
    max-width: 300px !important;
    padding: 15px;

    .tooltipInfoName {
      ${mixins.ellipsis};
      font-size: 13px;
      font-family: ${props => props.theme.fontBold}, serif;
      color: ${props => props.theme.brand};
    }
    .address {
      ${mixins.ellipsis};
    }
    .streetViewContainer {
      color: ${props => props.theme.brand};
      a {
        border-radius: 3px;
        padding: 2px 4px;
        color: ${props => props.theme.brand};
        border: 1px solid  ${props => props.theme.brand};
      }
    }
    i {
      width: 30px;
      height: 20px;
      color: ${props => props.theme.brand};
    }
    .mapboxgl-popup-close-button, .popupCloseButton {
      position: absolute;
      top: 0;
      right: 0;
      color: #333333;
      padding: 5px;
    }
  }

  .mapboxgl-ctrl.mapboxgl-ctrl-group {
    background-color: transparent;

    .mapboxgl-ctrl-zoom-in, .mapboxgl-ctrl-zoom-out {
      background-color: ${props => props.theme.uiColors.background01};
      width: 24px;
      height: 26px;

      & > span {
        background-size: 22px;
      }
    }

    .mapboxgl-ctrl-zoom-in {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    .mapboxgl-ctrl-zoom-out {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
`;
